<div class="card mb-0 main-card overflow-auto">
  <div class="card-header">
    <div class="d-flex align-items-center justify-content-between">
      <h5 class="card-title align-items-center d-flex p-0">Attorney Referral</h5>
      <div class="d-flex">
        <date-range-picker [fromDate]="fromDate" [toDate]="toDate" (toDateChange)="toDateChange($event)" (fromDateChange)="fromDateChange($event)"></date-range-picker>
        <button type="button" class="btn btn-outline-primary export-button" (click)="exportReport()">Export<i class="bi bi-box-arrow-right fs-5 mx-1"></i></button>
      </div>
    </div>
  </div>
  <div class="card-body p-0">
    <div class="table-responsive h-100">
      <table class="table table-hover table-x-padding mb-0" *ngIf="TotaReports || IsLoading">
        <thead>
          <tr>
            <th scope="col">#</th>
            <th scope="col">Name</th>
            <th scope="col">Case Type</th>
            <th class="text-end" scope="col">Date of Accident</th>
          </tr>
        </thead>
        <tbody>
          <ng-container *ngIf="!IsLoading">
            <ng-container *ngFor="let report of reportList">
              <ng-container *ngFor="let item of report.data">
                <tr>
                  <td colspan="4" style="font-weight: bold; background-color: #d7e4fe">
                    {{ report.month }}, {{ report.year }} - {{ item.attorneyName }}
                    <span class="badge text-dark bg-body-secondary ms-2">{{ item.patientCount }}</span>
                  </td>
                </tr>
                <tr *ngFor="let patient of item.patientDetails; index as i">
                  <th scope="row">{{ i + 1 }}</th>
                  <td>{{ patient.fullName }}</td>
                  <td>{{ patient.caseType }}</td>
                  <td class="text-end">{{ patient.dateOfAccident ? (patient.dateOfAccident | date : 'MM/dd/yyyy') : '-' }}</td>
                </tr>
              </ng-container>
            </ng-container>
          </ng-container>
          <ng-container *ngIf="IsLoading">
            <tr *ngFor="let report of ['', '', '', '', '']; index as i">
              <td *ngFor="let report of ['', '', '', '']; index as i">
                <p class="placeholder-glow">
                  <span class="placeholder col-12"></span>
                </p>
              </td>
            </tr>
          </ng-container>
        </tbody>
      </table>
      <div class="empty-data-placeholder" *ngIf="TotaReports == 0 && !IsLoading">
        <div class="text-center">
          <h3 class="text-body-tertiary"><i class="bi bi-exclamation-triangle"></i> Oops..!</h3>
          <p>No Reports Found</p>
        </div>
      </div>
    </div>
  </div>
</div>
